import { useQuery } from "@tanstack/react-query";
import { getFormSubmissionStats } from "../services/get-form-submission-stats";
import { FormSubmissionDailyCount } from "@/pages/forms/types/form";

export function useFormSubmissionStats(id?: string, days = 7) {
  return useQuery<FormSubmissionDailyCount[]>({
    queryKey: ["form", id, "submissions-daily", days],
    queryFn: () => getFormSubmissionStats(id as string, days),
    enabled: Boolean(id),
    refetchOnWindowFocus: false,
  });
}
